import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdrOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hdr_on"}/>
}
